import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { Service } from '../../../models';
import { JobsService, SnackbarService } from '../../../services/standard';
import { JobUploaderService } from '../../../services/standard/job-uploader.service';

@Component({
  selector: 'prism-job-upload-item',
  templateUrl: './job-upload-item.component.html',
  styleUrls: ['./job-upload-item.component.scss']
})
export class JobUploadItemComponent implements OnInit, AfterViewInit, OnDestroy {
  currentUploads$: Observable<any> = this.jobUploaderService.currentUploads$;
  address = '';
  jobDeliverPending = false;
  destroy$: Subject<void> = new Subject();
  job: Service = null;
  @Input() globalDeliveryPending;

  @Input() deleteInProgress;

  @Input()
  set jobInput(jobInput: Service) {
    if (!!jobInput) {
      this.job = jobInput;
    }
  }

  @Input() isSelectedJob;
  @Input() jobUploaded;
  @Input() index;

  @Output() jobDeliverPending$: EventEmitter<{ [jobId: string]: boolean }> = new EventEmitter<{ [jobId: string]: boolean }>();
  @Output() setCanDeliver: EventEmitter<{ id: string, lastDateDelivered: string, canDeliver: boolean }>
    = new EventEmitter<{ id: string, lastDateDelivered: string, canDeliver: boolean }>();

  @ViewChild('container', {static: true}) containerElement: ElementRef<HTMLDivElement>;

  constructor(private jobUploaderService: JobUploaderService,
              private snackbarService: SnackbarService,
              private changeRef: ChangeDetectorRef,
              private jobsService: JobsService) {
  }

  ngOnInit() {
  }


  ngAfterViewInit() {
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  deliverJob() {
    this.jobDeliverPending = true;
    this.jobDeliverPending$.emit({[this.job.id]: true});
    this.jobUploaderService.deliverJob(this.job)
      .then(() => {
        this.snackbarService.showSnackbar(`Service delivered. Member can now view assets uploaded to service ${this.job.id}`);
        this.jobDeliverPending$.emit({[this.job.id]: false});
        this.jobDeliverPending = false;

        const eventTimestamp = moment().utc().valueOf();

        this.job.timelineEvents[eventTimestamp] = {
          event: 'Service delivered',
          date: eventTimestamp
        };
        this.job.images.push(...this.job.imagesToDeliver);
        this.job.imagesToDeliver = [];

        if (!!this.jobsService.selectedJobCurrent && (this.jobsService.selectedJobCurrent.id === this.job.id)) {
          this.jobsService.setSelectedJob(this.job);
        }

      })
      .catch(err => {
        console.error('Could not deliver job:', err);
        this.jobDeliverPending = false;

      });
  }
}

interface DeliverReference {
  [service: string]: {
    lastDateDelivered: string,
    canDeliver: boolean
  };
}
